import { LOCATION_CHANGE } from 'connected-react-router';
import { CampaignActions, checkForWallet } from '../';

import { getSearchParams, setSearchParams } from '../../_core/queryparams';
import { authHelpers } from '../../Auth/helpers';
import { addressFromQuery, ipfsFromQuery } from '../../constants/regex';

export const campaignRegexp = /^.*(page((.*create)|(.*Qm[a-zA-Z0-9]{44})|(.*0x[a-fA-F0-9]{40})|(.*participation\/contributionDetails)))|(Qm[a-zA-Z0-9]{44}).*$/; // eslint-disable-line

const ipfsWithSecretRegex = /(Qm[a-zA-Z0-9]{44}\?s=[0-9A-Fa-f]{64})|(Qm[a-zA-Z0-9]{44})/;


export default ({ dispatch, getState }) => next => action => {
  if (action.type === LOCATION_CHANGE
    && campaignRegexp.test(action.payload.location.pathname)) {
    console.log('CAMPAIGN MIDDLEWARE', action);
    const [route] = action.payload.location.pathname.match(addressFromQuery)
      || action.payload.location.pathname.match(ipfsFromQuery) || [];
    const { s } = getSearchParams(action.payload.location.search) || {};
    const searchParam = setSearchParams(s ? { s } : {});
    const addressOrIpfsHash = route && `${route}${searchParam}`;
    console.log('addressOrIpfsHash', addressOrIpfsHash);
    console.log('addressOrIpfsHashREGEX', action.payload.location.pathname.match(ipfsWithSecretRegex));
    console.log('LOCATION_CHANGE_CAMPAIGN', action.payload.location.pathname);

    const campaignFlowLoading = getState().campaign.get('campaignFlowLoading');
    const campaignAddress = getState().campaign.getIn(['campaign', 'web3_address']);

    console.log('campaignFlowLoading 1', campaignFlowLoading);
    // if (addressOrIpfsHash && clearAddressOrHash(campaignFlowLoading) !== clearAddressOrHash(addressOrIpfsHash)) {
    if (addressOrIpfsHash && campaignFlowLoading !== addressOrIpfsHash) {
      next(action);
      if (!campaignFlowLoading && campaignAddress !== addressOrIpfsHash) {
        dispatch({ type: 'SET_CAMPAIGN_FLOW_LOADING', payload: addressOrIpfsHash });
      }
      console.log('SET_CAMPAIGN_FLOW_LOADING', { addressOrIpfsHash, campaignAddress });
      (authHelpers.isAuthenticated() ? checkForWallet(getState) : Promise.resolve()).then(() => {
        console.log('SET_CAMPAIGN_FLOW_LOADING', { campaignFlowLoading, addressOrIpfsHash, campaignAddress });
        if (campaignFlowLoading !== addressOrIpfsHash && campaignAddress !== addressOrIpfsHash) {
          dispatch(CampaignActions.CAMPAIGN_LOADING_PROCESS(addressOrIpfsHash));
        }
      }).catch(err => {
        console.warn('checkForWallet', err);
      });
    } else {
      next(action);

      if (!addressOrIpfsHash) {
        dispatch(CampaignActions.RESET_ACQUISITION_CAMPAIGN_META());
      }
    }
  } else {
    next(action);
  }
};
